import { createFileRoute } from "@tanstack/react-router"
import { parseExperimentTab } from "./-experiments"
import { AdminExperimentsWrapper } from "./-ExperimentsPage"

export const Route = createFileRoute("/admin/experiments")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: parseExperimentTab(search.tab),
    experiment: typeof search.experiment === "string" ? search.experiment : undefined,
  }),
  component: AdminExperimentsWrapper,
})
